import './formConfig.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import 'material-symbols';
import axios from 'axios';
import 'swiper/css';
import 'swiper/css/navigation';

import "./block-100-days.js";
import "./block-delivery.js";
import "./block-faq.js";
import "./block-infos-cards.js";
import "./block-installation.js";
import "./block-newsletter.js";
import "./block-reassurance.js";
import "./block-steps.js";
import "./block-testimonial.js";
import "./cards-photo.js";
import "./config.js";
import "./ecosystem.js";
import "./hero.js";
import "./plug-and-save.js";
import "./plug-and-save-teaser.js";
import "./video-details.js";
import "./contact-modal.js";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
    const isMobileFirstLoad = window.innerWidth < 768;
    const normalizeScroll = () => {
        // if we are on mobile
        if (window.innerWidth < 768) {
            // we need to remove the scroll from the body
        } else {
            // if we are on desktop we need to add the scroll to the body
            ScrollTrigger.normalizeScroll(false);
        }
    };

    normalizeScroll();

    window.addEventListener('resize', () => {
        normalizeScroll();
    });

    const apiBaseUrl = "https://api.monkitsolaire.fr";

    const elementsNewsletter = {
        email: document.getElementById('email'),
        rgpd: document.getElementById('rgpd'),
        submit: document.getElementById('news-submit'),
        showErrorMessage: document.getElementById('show-error-message'),
        form: document.querySelector('.form-news-mksun'),
        confirm: document.querySelectorAll('.mksun-block-newsletter__content__confirm')
    };

    const elementsNewsletterFooter = {
        email: document.getElementById('footer-email'),
        rgpd: document.getElementById('footer-rgpd'),
        submit: document.getElementById('footer-news-submit'),
        showErrorMessage: document.getElementById('footer-show-error-message'),
        form: document.querySelector('.mksun-layout-footer__footer__ctn__newsletter'),
        confirm: document.querySelectorAll('.mksun-block-newsletter__content__confirm')
    };

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return regex.test(email);
    };

    const validateRgpd = (rgpd) => rgpd.checked;

    const checkStorageNewsletter = () => {
        if (localStorage.getItem('isRegisterNewsletterMksun') === 'true') {
            elementsNewsletter.form.style.display = 'none';
            elementsNewsletter.form.style.display = 'none';
            elementsNewsletter.confirm[0].style.display = 'block';

            // déplacer la confirmation dans l'input du footer
            //elementsNewsletterFooter.form.insertAdjacentHTML('beforeend', document.querySelector('.mksun-layout-footer .mksun-block-newsletter__content__confirm').outerHTML);


        } else {
            elementsNewsletter.confirm.forEach(el => el.style.display = 'none');
        }
    };

    checkStorageNewsletter();

    const handleSubmit = async (e, el) => {
        //e.preventDefault();
        if (validateEmail(el.email.value) && validateRgpd(el.rgpd)) {
            try {
                const response = await axios.get(
                    `${apiBaseUrl}/PrestaShop/RegisterToNewsletter/${el.email.value}`
                );

                el.showErrorMessage.innerHTML = '';

                if (response.data.success) {
                    el.showErrorMessage.style.display = 'none';
                    el.form.style.display = 'none';
                    el.confirm.forEach(el => el.style.display = 'block');
                    el.email.value = '';
                    el.rgpd.checked = false;
                    localStorage.setItem('isRegisterNewsletterMksun', true);
                } else {
                    el.showErrorMessage.innerHTML = response.data.message;
                    el.showErrorMessage.style.display = 'block';
                }
            } catch (error) {
                el.showErrorMessage.innerHTML =
                    'Une erreur est survenue, veuillez réessayer';
            }
        } else {
            if (!validateEmail(el.email.value)) {
                el.email.value = '';
                el.showErrorMessage.innerHTML = 'Adresse email invalide';
                el.showErrorMessage.style.display = 'block';
            } else if (!validateRgpd(el.rgpd)) {
                el.showErrorMessage.innerHTML =
                    "Vous devez accepter les conditions d'utilisation";
                el.showErrorMessage.style.display = 'block';
            }
        }
    };

    elementsNewsletter.submit.addEventListener('click', (e) => handleSubmit(e, elementsNewsletter));
    elementsNewsletterFooter.submit.addEventListener('click', (e) => handleSubmit(e, elementsNewsletterFooter));

    window.addEventListener('resize', () => {
        //ScrollTrigger.refresh()
    });

    document.querySelectorAll('.toggle-mini-config').forEach((el) => {
        el?.addEventListener('click', () => {
            window?.mksunMC?.changeStyleMiniConfig(false);
        });
    });

    document
        .querySelector(
            '#header > div.ets_mm_megamenu.layout_layout1.show_icon_in_mobile.transition_fade.transition_floating.sticky_enabled.ets-dir-ltr.hook-default.single_layout.disable_sticky_mobile > div > div > div > ul > li.mm_menus_li.btn-config.mm_sub_align_full > a'
        )
        ?.addEventListener('click', (e) => {
            e.preventDefault();
            window?.mksunMC?.changeStyleMiniConfig(false);
        });

    document.querySelectorAll('.toggle-popup-contact-mksun').forEach((el) => {
        el?.addEventListener('click', () => {
            window?.mksunMC?.displayModaleCalendly(true);
        });
    });

    const resizeBody = new ResizeObserver(() => {
        ScrollTrigger.refresh();
    });

    resizeBody.observe(document.querySelector('body'));
});


